"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.compareUpdateHash = void 0;
const shared_1 = require("../shared");
function compareUpdateHash(context, classifierName, defaultValues, callback) {
    const classifierHashStorage = context.storage(shared_1.classifierHashEntityName);
    const [classifierHashRow] = classifierHashStorage.list({ filter: [{ column: 'classifierName', op: '=', value: classifierName }] }).rows;
    const hash = context.encryption.hash('SHA-1', JSON.stringify(defaultValues));
    if (!classifierHashRow) {
        callback();
        classifierHashStorage.post({
            action: 'create',
            data: {
                classifierName: classifierName,
                hash: hash,
            },
        });
    }
    else if (hash !== classifierHashRow.columns.hash) {
        callback();
        classifierHashStorage.post({
            action: 'partial-update',
            id: classifierHashRow.id,
            data: {
                hash: hash,
            },
        });
    }
}
exports.compareUpdateHash = compareUpdateHash;
